/**
 * @flow
 * @relayHash 63026870b0588043f34d5962821bc1b6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SelectedFactsetFundList_viewer$ref = any;
export type SelectedFactsetFundListQueryVariables = {|
  first?: ?number,
  offset?: ?number,
  search?: ?string,
  isin?: ?string,
|};
export type SelectedFactsetFundListQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: SelectedFactsetFundList_viewer$ref
  |}
|};
export type SelectedFactsetFundListQuery = {|
  variables: SelectedFactsetFundListQueryVariables,
  response: SelectedFactsetFundListQueryResponse,
|};
*/


/*
query SelectedFactsetFundListQuery(
  $first: Int
  $offset: Int
  $search: String
  $isin: String
) {
  viewer {
    ...SelectedFactsetFundList_viewer_7kEXr
    id
  }
}

fragment SelectedFactsetFundList_viewer_7kEXr on Query {
  factsetSupportedFundContracts(first: $first, offset: $offset, search: $search, factsetContract_Isin: $isin) {
    edges {
      node {
        id
        createdAt
        updatedAt
        factsetContract {
          exchangeSymbol
          fsymId
          id
          currency
          isin
          name
        }
      }
    }
    count
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isin",
    "type": "String",
    "defaultValue": null
  }
],
v1 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v2 = {
  "kind": "Variable",
  "name": "offset",
  "variableName": "offset"
},
v3 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SelectedFactsetFundListQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SelectedFactsetFundList_viewer",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Variable",
                "name": "isin",
                "variableName": "isin"
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SelectedFactsetFundListQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "factsetSupportedFundContracts",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "factsetContract_Isin",
                "variableName": "isin"
              },
              (v1/*: any*/),
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "concreteType": "FactsetSupportedFundContractNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "FactsetSupportedFundContractNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "FactsetSupportedFundContractNode",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "createdAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "updatedAt",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "factsetContract",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FactsetContractNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "exchangeSymbol",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "fsymId",
                            "args": null,
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "currency",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isin",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "name",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "count",
                "args": null,
                "storageKey": null
              }
            ]
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "SelectedFactsetFundListQuery",
    "id": null,
    "text": "query SelectedFactsetFundListQuery(\n  $first: Int\n  $offset: Int\n  $search: String\n  $isin: String\n) {\n  viewer {\n    ...SelectedFactsetFundList_viewer_7kEXr\n    id\n  }\n}\n\nfragment SelectedFactsetFundList_viewer_7kEXr on Query {\n  factsetSupportedFundContracts(first: $first, offset: $offset, search: $search, factsetContract_Isin: $isin) {\n    edges {\n      node {\n        id\n        createdAt\n        updatedAt\n        factsetContract {\n          exchangeSymbol\n          fsymId\n          id\n          currency\n          isin\n          name\n        }\n      }\n    }\n    count\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'afd2d0ccbe7fcd07c38b23648975dbff';
module.exports = node;
